import React from 'react';
import '../styles/Disqualifier.css';
import { Sparkle } from '../assets/icons';
import { colour } from '../styles/GlobalStyles';
import { Typewriter } from './';

function Disqualifier(props) {
    const text = props.text;
    const loading = props.loading;
    const loadingText = `**Cookin up a storm**`;
    return (
        <div className="disqualifier-container">
            <div className="disqualifier-inner-container">
                <div className="disqualifier-icon-container">
                    <Sparkle
                        fill={colour.red02}
                        className="disqualifier-sparkle"
                        gradient={false}
                    />
                </div>
                <Typewriter
                    text={
                        loading ? 
                        loadingText 
                        :
                        text
                    }
                    delay={10}
                    commaDelay={0}
                    fullStopDelay={0} 
                    play={true}
                    className="body-regular colour-primary block-text white-space-pre-wrap"
                    isHTML={true}
                    onComplete={null}
                />
            </div>
        </div>
    )
};

export default Disqualifier;